import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import GameCategorySection from './components/GameCategorySection';
import PromotionSection from './components/PromotionSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import ArticleSection from './components/ArticleSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'j9官方平台',
  url: 'https://j9guanwang.com/',
  description: 'j9是备受用户信赖的综合娱乐平台，提供丰富游戏体验、安全支付保障与极速提款服务。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9999',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
    hoursAvailable: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59',
    },
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'j9官方平台',
  url: 'https://j9guanwang.com/',
  description: 'j9是备受用户信赖的综合娱乐平台，提供丰富游戏体验、安全支付保障与极速提款服务。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://j9guanwang.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'j9平台如何注册账号？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '注册j9账号非常简单快捷。点击网站右上角的"j9注册"按钮，填写手机号码或邮箱地址，设置登录密码，完成手机验证码或邮箱验证即可。整个注册流程仅需1分钟，注册成功后即可享受平台全部服务。',
      },
    },
    {
      '@type': 'Question',
      name: 'j9平台提款需要多长时间？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'j9平台采用智能审核系统，大部分提款申请可在5-10分钟内完成审核并到账。',
      },
    },
    {
      '@type': 'Question',
      name: 'j9平台是否安全可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'j9平台持有正规运营牌照，采用国际标准的SSL加密技术和多重安全防护体系，确保用户信息和资金安全。',
      },
    },
    {
      '@type': 'Question',
      name: 'j9支持哪些支付方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'j9平台支持多种便捷支付方式，包括银行卡转账、微信支付、支付宝、USDT等主流支付渠道。',
      },
    },
    {
      '@type': 'Question',
      name: 'j9有哪些优惠活动？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'j9平台为新老用户准备了丰富的优惠活动，包括新用户首充100%返利、每日签到领金币、好友邀请双赢计划等。',
      },
    },
    {
      '@type': 'Question',
      name: '遇到问题如何联系客服？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'j9平台提供7×24小时全天候在线客服服务。您可以通过网站右下角的在线客服按钮、官方客服电话联系。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg schema={organizationSchema} />
      <SchemaOrg schema={websiteSchema} />
      <SchemaOrg schema={faqSchema} />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <FeatureSection />
          <GameCategorySection />
          <PromotionSection />
          <TestimonialSection />
          <ArticleSection />
          <FAQSection />
        </article>
      </main>

      <Footer />
    </>
  );
}